var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#44486C",
    stroke: "#44486C",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.594 3.159h-3.04v-.51C10.553 1.74 9.831 1 8.944 1h-2.89c-.887 0-1.608.74-1.608 1.65v.509h-3.04A.41.41 0 001 3.575c0 .231.18.416.406.416h.733v9.782c0 1.228.974 2.227 2.17 2.227h6.382c1.196 0 2.17-1 2.17-2.227V3.991h.733A.41.41 0 0014 3.575a.41.41 0 00-.406-.416zm-8.336-.51c0-.45.358-.816.797-.816h2.89c.44 0 .797.367.797.817v.509H5.258v-.51zm6.792 11.124c0 .768-.61 1.394-1.359 1.394H4.31c-.749 0-1.359-.626-1.359-1.394V3.991h9.103v9.782h-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.931c.278 0 .5-.187.5-.42V6.075c0-.234-.222-.42-.5-.42s-.5.186-.5.42v7.431c0 .234.222.424.5.424zM5 13.414c.278 0 .5-.184.5-.415V6.587c0-.23-.222-.415-.5-.415s-.5.185-.5.415v6.412c0 .23.226.415.5.415zm5 0c.278 0 .5-.184.5-.415V6.587c0-.23-.222-.415-.5-.415s-.5.185-.5.415v6.412c0 .23.222.415.5.415z"
  }))));
}

export default __webpack_public_path__ + "./fonts/trash.bd1a488225f109a3902c359392708c7f.svg";
export { SvgTrash as ReactComponent };